import { orgGuidTourFun } from '../../../../api/orgGuidAPI';
import errorHandle from '../../../../utils/errorHandle';

export const fetchOrgGuideDetails = async (guideId, setGuidData, setLoading) => {
    setLoading(true);
    try {
        const response = await orgGuidTourFun(guideId);
        setGuidData(response.data[0]);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
